import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export type QuickActionChip = {
  id: string;
  label: string;
  onClick?: () => void;
};

export function QuickActions({
  chips,
  className,
}: {
  chips: QuickActionChip[];
  className?: string;
}) {
  if (!chips.length) return null;
  return (
    <div
      className={cn(
        'flex flex-nowrap items-center gap-2 overflow-x-auto no-scrollbar -mx-1 px-1 py-1',
        className,
      )}
      role="group"
      aria-label="Suggested next steps"
    >
      {chips.map((c) => (
        <Button
          key={c.id}
          type="button"
          variant="outline"
          size="sm"
          onClick={c.onClick}
          className="shrink-0 rounded-full whitespace-nowrap"
        >
          {c.label}
        </Button>
      ))}
    </div>
  );
}

export function buildQuickActionChips(opts: {
  openActionCount: number;
  topActionTitle: string | null;
  onWorkOnTop?: () => void;
  onSeeAllTodos?: () => void;
  onLogPulse?: () => void;
  onSeePastConversations?: () => void;
  onSomethingElse?: () => void;
}): QuickActionChip[] {
  const { openActionCount, topActionTitle } = opts;
  if (openActionCount === 0) {
    return [
      { id: 'log-pulse', label: 'Log a pulse', onClick: opts.onLogPulse },
      { id: 'past-conversations', label: 'See past conversations', onClick: opts.onSeePastConversations },
      { id: 'something-else', label: 'Something else', onClick: opts.onSomethingElse },
    ];
  }
  const workLabel = topActionTitle ? `Work on: ${topActionTitle}` : 'Work on top to-do';
  return [
    { id: 'work-on-top', label: workLabel, onClick: opts.onWorkOnTop },
    { id: 'see-all-todos', label: 'See all to-dos', onClick: opts.onSeeAllTodos },
    { id: 'something-else', label: 'Something else', onClick: opts.onSomethingElse },
  ];
}
